
import { mapState, mapGetters } from "vuex";
import backButtonFullHeight from "../common/back-button-full-height.vue";
const DELETE_AND_MOVE = "deleteAndMove";
const DELETE = "delete";
export default {
  components: { backButtonFullHeight },
  props: {
    loading: {
      default: false,
      type: Boolean
    },
    currentSubCategoryId: {
      type: Number,
      required: true
    },
    currentCategoryId: {
      type: Number,
      required: true
    },
    subCategoriesForDeletion: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      selectedOption: DELETE,
      selectedCategory: {},
      DELETE_AND_MOVE,
      DELETE,
      options: [
        {
          value: DELETE,
          label: "Delete sub category and associated items"
        },
        {
          value: DELETE_AND_MOVE,
          label: "Delete sub category and relocate items"
        }
      ]
    };
  },
  computed: {
    ...mapState("menu", ["categories", "menuUploadList"]),
    ...mapGetters("menu", ["getCategoryObj"]),
    getCategoriesAndSubcategories() {
      const categories = this.categories.map((category) => ({
        id: category.id,
        name: category.category_name,
        subAttributes: category.subcategories?.map((sub) => ({
          id: sub.id,
          name: sub.subcategory_name
        }))
      }));

      return this.flattenedAttributes(categories);
    },

    isItemsAssignedToCategory() {
      let items = this.menuUploadList?.filter((item) => {
        return item?.sub_category_id === this.currentSubCategoryId;
      });
      return items;
    }
  },
  methods: {
    isSubCategorySelectedForDeletion(category) {
      return this.subCategoriesForDeletion?.some(
        (subCategory) => subCategory.id === category.id
      );
    },
    handleSave() {
      this.$emit("delete-sub-category", {
        selectedOption: this.selectedOption,
        selectedCategory:
          this.selectedOption === DELETE_AND_MOVE ? this.selectedCategory : null
      });
    }
  }
};
